import {
  OWNER_JARVIS_CONFIRMATION,
  OWNER_JARVIS_OPERATION_KIND,
} from "./ownerJarvisCapabilityContract";

const SAFE = OWNER_JARVIS_OPERATION_KIND.SAFE_WRITE;
const SENSITIVE = OWNER_JARVIS_OPERATION_KIND.SENSITIVE_WRITE;

const POLICIES = Object.freeze({
  jarvisTurn: { kind: SAFE, scopes: ["today", "commitments", "projects", "people", "waiting", "calendar"] },
  updateCalendarSettings: { kind: SAFE, scopes: ["today", "calendar", "routines"] },
  createRoutine: { kind: SAFE, scopes: ["today", "calendar", "routines"] },
  updateRoutine: { kind: SAFE, scopes: ["today", "calendar", "routines"] },
  setRoutineCheckin: { kind: SAFE, scopes: ["today", "calendar", "routines"] },
  createLifeEntry: { kind: SAFE, scopes: ["today"] },
  updateLifeEntry: { kind: SAFE, scopes: ["today"] },
  resolveLifeEntryRetrospective: { kind: SAFE, scopes: ["today", "commitments", "projects", "people", "calendar"] },
  createCommitment: { kind: SAFE, scopes: ["today", "commitments", "people", "waiting", "calendar"] },
  updateCommitment: { kind: SAFE, scopes: ["today", "commitments", "people", "waiting", "calendar"] },
  addCommitmentTime: { kind: SAFE, scopes: ["today", "commitments", "calendar"] },
  createInitiative: { kind: SAFE, scopes: ["today", "projects", "people", "waiting"] },
  createProjectSteps: { kind: SAFE, scopes: ["today", "commitments", "projects", "waiting", "calendar"] },
  reorderProjectSteps: { kind: SAFE, scopes: ["today", "commitments", "projects", "waiting", "calendar"] },
  answerProjectDailyLoop: { kind: SAFE, scopes: ["today", "commitments", "projects", "people", "waiting", "calendar"] },
  updateInitiative: { kind: SAFE, scopes: ["today", "projects", "people", "waiting"] },
  deleteInitiative: { kind: SENSITIVE, scopes: ["today", "projects", "people", "waiting"] },
  syncProjectWebProfitBilling: { kind: SENSITIVE, scopes: ["projects", "finance"] },
  createProjectTerm: { kind: SENSITIVE, scopes: ["projects", "finance"] },
  updateProjectTerm: { kind: SENSITIVE, scopes: ["projects", "finance"] },
  createProjectPaymentPlan: { kind: SENSITIVE, scopes: ["projects", "finance"] },
  updateProjectPaymentPlan: { kind: SENSITIVE, scopes: ["projects", "finance"] },
  reconcileProjectPaymentPlan: { kind: SENSITIVE, scopes: ["projects", "finance"] },
  bulkLinkProjectPayments: { kind: SENSITIVE, scopes: ["projects", "finance"] },
  bulkLinkProjectMonthlyHistory: { kind: SENSITIVE, scopes: ["projects", "finance"] },
  createFinanceAccount: { kind: SAFE, scopes: ["finance"] },
  updateFinanceAccount: { kind: SAFE, scopes: ["finance"] },
  createFinanceCategory: { kind: SAFE, scopes: ["finance"] },
  updateFinanceCategory: { kind: SENSITIVE, scopes: ["finance"] },
  createFinanceTransaction: { kind: SAFE, scopes: ["finance"] },
  updateFinanceTransaction: { kind: SENSITIVE, scopes: ["finance"] },
  createInventoryMovement: { kind: SAFE, scopes: [] },
  createRecurringFinance: { kind: SAFE, scopes: ["finance", "people"] },
  updateRecurringFinance: { kind: SENSITIVE, scopes: ["finance", "people"] },
  updateRecurringOccurrence: { kind: SAFE, scopes: ["finance", "people"] },
  recordRecurringFinance: { kind: SAFE, scopes: ["finance", "people"] },
  linkFinanceTransactionRecurring: { kind: SENSITIVE, scopes: ["finance"] },
  createInfrastructure: { kind: SAFE, scopes: ["finance"] },
  updateInfrastructure: { kind: SENSITIVE, scopes: ["finance"] },
  endInfrastructure: { kind: SENSITIVE, scopes: ["finance"] },
  commitFinanceImport: { kind: SENSITIVE, scopes: ["finance"] },
  createClient: { kind: SAFE, scopes: ["people"] },
  updateClient: { kind: SAFE, scopes: ["people"] },
  linkClientWebProfitUser: { kind: SENSITIVE, scopes: ["people"] },
  linkClientWebProfitProject: { kind: SENSITIVE, scopes: ["people", "projects"] },
  createInteraction: { kind: SAFE, scopes: ["people"] },
  createService: { kind: SAFE, scopes: ["people", "finance"] },
  updateService: { kind: SENSITIVE, scopes: ["people", "finance"] },
  createSale: { kind: SAFE, scopes: ["people", "finance"] },
  updateSaleStatus: { kind: SENSITIVE, scopes: ["people", "finance"] },
  createSalePayment: { kind: SENSITIVE, scopes: ["people", "finance"] },
});

export function ownerJarvisOperationPolicyForApiMethod(method) {
  const policy = POLICIES[String(method)] || null;
  if (!policy) return null;
  return Object.freeze({
    method: String(method),
    kind: policy.kind,
    confirmation: policy.kind === SENSITIVE ? OWNER_JARVIS_CONFIRMATION.REQUIRED : OWNER_JARVIS_CONFIRMATION.NEVER,
    scopes: Object.freeze([...(policy.scopes || [])]),
  });
}

export function ownerJarvisApiMethodIsSensitive(method) {
  return ownerJarvisOperationPolicyForApiMethod(method)?.kind === SENSITIVE;
}

export const OWNER_JARVIS_API_OPERATION_POLICIES = POLICIES;
